<template>
  <div>
    <compact-picker v-model="color" class="colorPicker" @input="updateValue"/>
  </div>
</template>

<script>
import { Compact } from 'vue-color';

export default {
  name: 'color-picker',
  props: ['props', 'couleur'],
  components: {
    'compact-picker': Compact,
  },
  data() {
    return {
      color: { hex: this.couleur },
    };
  },
  methods: {
    updateValue() {
      this.$emit('colorsPickerChange', { color: this.color, props: this.props });
    },
  },
};
</script>

<style scoped>
  .colorPicker {
    width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/colorPicker.vue